import { Permission, useFeatureFlag, usePermission, Variant } from '@bonusly/who-am-i';

export const useOneOnOnesAccess = () => {
	const hasOneOnOnesPermission = usePermission(Permission.CanAccessOneOnOnes);
	const hasOneOnOnesEarlyAccess = useFeatureFlag(Variant.OneOnOnesEarlyAccess);
	const hasOneOnOnesLimitedRelease = useFeatureFlag(Variant.OneOnOnesLimitedRelease);
	const canAccessOneOnOnes = hasOneOnOnesPermission || hasOneOnOnesEarlyAccess || hasOneOnOnesLimitedRelease;

	return {
		canAccessOneOnOnes,
	};
};
